module.exports = __webpack_public_path__ + "img/logo.b932b748.png";